import { PlanInfo } from "./planInfo";
export class ZoneFeature {
  refId: string;
  zoneType: string ="";
  forkortels: string;
  layerName: string;
  planInfo: PlanInfo;
  geometry: JSON;
}
